// var customStyleContent = `.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdBottom{height:120px}.kuProdBottom .kuName{overflow:auto;display:block;-webkit-box-orient:unset;-webkit-line-clamp:unset}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdBottom{height:150px}.kuClippedOne{display:block!important}.kuSearchResultsPageContainer .kuResults ul li .kuName a{word-break:break-word}`;
var customStyleContent = `.kuProdBottom .kuName{overflow:auto;display:block;-webkit-box-orient:unset;-webkit-line-clamp:unset}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdBottom{height:150px}.kuClippedOne{display:block!important}.kuSearchResultsPageContainer .kuResults ul li .kuName a{word-break:break-word}`;
/** ETEMPA STYLE EDITS */

customStyleContent += `

    h1, .h1 {
      text-align: center;
      font-size: var(--font-size-heading-1);
    }

    .kuContainer, .kuLandingNoRecordFound, .kuLandingNoResults {
        background-color: #f9f9f9;
    }

    .kuLandingNoRecordFound .kuLandingNoResultsMessage {
      font-size: 18px!important;
      font-family: 'Karla';
    }

    [ku-container] a, [ku-container] p, [ku-container] div, [ku-container] ul li {
      font-size: .9375rem;
    }

    .kuSearchResultsPageContainer .kuResults ul {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        grid-gap: 20px;
        padding: 20px 5px 20px 5px !important;
    }

    .kuSearchResultsPageContainer .kuResults ul li {
        border: 1px solid rgba(125,125,125,.16);
        box-shadow: 0 1px 4px #7d7d7d1c;
        width: 100%;
        min-height: 100%;
        height: var(--base-height, auto);
        padding: 1.015625rem;
        background: rgb(249,249,249);
        transition: height .25s cubic-bezier(.4,0,.2,1),box-shadow .25s cubic-bezier(.4,0,.2,1);
        display: grid;
    }

    .kuSearchResultsPageContainer .kuResults ul li:hover {
        box-shadow: 0 2px 8px rgba(125,125,125,.2);
        border-color: #7d7d7d33;
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuProdWrap {
        border: unset;
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop {
        padding: 0;
        height: unset !important;
        position: relative;
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap {
        height: 100% !important;
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a img {
        margin: 0;
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        object-fit: cover;
        object-position: top;
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a.gPreorderImageWrapper img {
      max-height: unset!important;
      height: auto!important;
      transform: unset;
      top: 0;
      left: 0;
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop img {
      width: 100%;
      height: 172px;
      object-fit: contain;
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdBottom {
        padding: 0;
        height: 100%;
        margin-bottom: 10px;
    }

    .klevuNoResultsRecs-itemPrice .kuSalePrice, .productQuick-Price .kuSalePrice, .kuPrice .kuSalePrice, .kuSalePrice {
        color: #c71f19;
        font-size: var(--font-size-body-larger);
        line-height: 1.4375rem;
        font-weight: 400;
        margin: 0;
    }

    .klevuNoResultsRecs-itemPrice .kuOrigPrice, .productQuick-Price .kuOrigPrice, .kuPrice .kuOrigPrice {
        position: absolute;
        top: -7px;
    }

    .priceRow {
        display: grid;
        grid-template-columns: 1fr auto;
        grid-gap: 5px;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .priceRow .productType {
        align-self: end;
    }

    .priceRow .productType span {
        text-align: right;
        font-weight: 700;
        font-size: 12px;
        font-family: Karla,sans-serif;
    }

    .kuProdBottom .artistAuthor {
        font-weight: 700;
    }

    .kuProdBottom .kuPrice {
      overflow: unset;
      font-family: 'Karla';
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuName a, .kuProdBottom .artistAuthor span {
      word-break: break-word;
      font-size: var(--font-size-body);
      font-family: 'Karla';
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuName, .kuProdBottom .artistAuthor {
      text-align: left;
      font-size: var(--font-size-body);
      font-family: 'Karla';
    }

    .kuProdTop .discountLabel {
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: red;
        padding: 2px 5px;
        line-height: normal;
        color: white;
        font-weight: 700;
    }

    .kuProdTop .discountLabel.soldOutLabel {
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: black;
        padding: 2px 5px;
        line-height: normal;
        color: white;
        font-weight: 700;
    }

    .kuSearchResultsPageContainer .kuResults ul li .product-form--atc-button {
      margin: 0;
      display: block;
      width: 100%;
      max-height: 49.41px;
      align-self: end;
      font-size: var(--font-size-body);
    }

	.kuSearchResultsPageContainer .kuResults ul li .kuProdBottom .product-form--atc-button {
	  width: 150px;
      margin-top: 20px;
	}
	
    .kuSearchResultsPageContainer .kuResults ul li .product-form--atc-button:focus, .kuSearchResultsPageContainer .kuResults ul li .product-form--atc-button:active {
      outline: none;
    }

    .kuSearchResultsPageContainer [data-result-view='list'] .kuResults ul {
      grid-template-columns: 1fr;
    }

    .kuSearchResultsPageContainer [data-result-view='list'] .kuResults ul .kuProdWrap {
      display: grid;
      grid-template-columns: 0 180px 2fr;
    }

    .kuSearchResultsPageContainer [data-result-view='list'] .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap, .kuSearchResultsPageContainer .kuResults ul.list-view li .kuProdWrap .kuProdBottom {
      margin: 0;
    }

    .kuSearchResultsPageContainer [data-result-view='list'] .kuResults .klevuProduct main {
      margin: 0;
      width: 100%;
    }

    .kuSearchResultsPageContainer [data-result-view='list'] .kuResults .klevuProduct footer {
      width: 100%;
      padding-left: 20px;
    }

    .kuSearchResultsPageContainer .kuPagination a {
      padding-left: 10px;
      margin-left: -4px;
    }

    .kuSearchResultsPageContainer footer .kuPagination, #mobile-top-pagination .kuPagination {
      float: unset;
      text-align: center;
    }

    .kuSearchResultsPageContainer .kuPagination a.kuCurrent {
      color: #c71f19;
      font-weight: 800;
      border-bottom: solid 1px #c71f19;
    }

    #mobile-top-pagination {
      display: none;
    }

    .kuLandingNoResults {
      max-width: unset;
      max-width: 1000px;
    }

    .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner {
      display: block;
      flex-wrap: unset;
    }

    .kuLandingNoRecordFound, .kuLandingNoResults {
      margin-top: 0;
    }

    .kuFilterBox .kuFilterNames {
      height: 135px;
    }

    .site-header-sticky .atc-banner--container {
      opacity: 100;
      position: relative;
      top: 0;
      transform: unset;
    }

    .site-header-sticky .atc-banner--container .atc--product-details--price-discounted {
      text-decoration: line-through;
      opacity: 0.5;
    }

    .productitem {
      display: grid;
    }

    .productitem--actions {
      align-self: end;
    }

    .productitem--action {
      padding: 0;
    }

    .product-title {
      text-align: left;
    }

    .preorder-badge {
        position: absolute;
        width: fit-content;
        top: 5px;
        right: 5px;
        color: #fff;
        background-color: #c71f19;
        padding: 5px 10px;
        border-radius: 2px;
        font-weight: 600;
		z-index: 2;
    }

    .preorder-button {
        background-color: #E5902E;
        border-color: #E5902E;
    }

    .klevuFilter[data-filter="variantid"], .klevuFilter[data-filter="inventoryQuantity"] {
      display: none;
    }

.preorder-button.button-primary:not(.disabled):hover, .preorder-button.product-form--atc-button:not(.disabled):hover {
      background-color: #ef9b3b !important;
      border-color: #ef9b3b !important;
    }

    @media only screen and (min-width: 481px) and (max-width: 1024px) {
        .kuSearchResultsPageContainer.kuLEFTFilters .kuResults ul li, .kuSearchResultsPageContainer.kuRIGHTFilters .kuResults ul li {
            width: 100%;
        }
    }

    @media only screen and (max-width: 1024px) {
      #mobile-filters-bar {
        display: grid;
        grid-template-columns: auto auto 1fr auto;
        padding: 0 10px;
      }

      #mobile-filters-bar .utils-filter {
        display: block;
      }

      #mobile-filters-bar .utils-sortby-title, #mobile-filters-bar .utils-sortby-select--wrapper {
        display: none;
      }

      #mobile-filters-bar .utils-sortby-button {
        display: block;
      }

      #mobile-filters-bar .utils-viewtoggle-button {
        padding: 12px;
      }

      .kuSearchResultsPageContainer [ku-container][data-container-role="left"], .kuSearchResultsPageContainer [ku-container][data-container-role="right"], [ku-container][data-container-id="ku_landing_main_content_center"] {
        width: 100%;
        display: block;
        max-width: unset;
      }

      .utils-viewtoggle-button:hover, .utils-viewtoggle-button.active {
        color: #c71f19;
        border: 0;
        outline: none !important;
        box-shadow: unset;
        background-color: #f4e3e2;
      }

      .kuFilters, [data-block-id="ku_landing_result_header"] {
        display: none;
      }

      #mobile-sort-by-popover {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 99999998;
        background-color: rgba(0,0,0,0.5);
      }

      #sort-by-popover-inner {
        position: absolute;
        top: 50vh;
        left: 50vw;
        width: 70vw;
        z-index: 99999999;
        transform: translate(-50%, -50%);
        border: 1px solid rgba(125,125,125,.16);
        box-shadow: 0 1px 4px #7d7d7d1c;
        background: rgb(249,249,249);
      }

      .sort-by-popover-option {
        padding: 30px;
        text-align: center;
        color: #c71f19;
      }

      .sort-by-popover-option:hover, .sort-by-popover-option:active {
        background-color: #c71f19;
        color: white;
      }

      .sort-by-popover-option:not(:last-child) {
        border-bottom: 1px solid rgba(125,125,125,.16);
      }

      #mobile-top-pagination {
        display: block;
        width: 100%;
      }

      .klevuNoResultsRecsResults .kuSearchResultsPageContainer .kuResults ul {
        grid-gap: 10px;
      }

      .klevuNoResultsRecsResults .kuSearchResultsPageContainer .kuResults ul li {
        padding: 10px;
      }
    }

    @media only screen and (min-width: 768px) and (max-width: 900px) {
      .klevuNoResultsRecsResults .kuSearchResultsPageContainer .kuResults ul {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      }
    }

    @media only screen and (min-width: 550px) and (max-width: 768px) {
      .klevuNoResultsRecsResults .kuSearchResultsPageContainer .kuResults ul {
        grid-gap: 20px;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      }

      .klevuNoResultsRecsResults .kuSearchResultsPageContainer .kuResults ul li {
        padding: 20px;
      }
    }

    @media only screen and (min-width: 470px) and (max-width: 768px) {
      .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner {
        max-width: unset !important;
      }
    }

    @media only screen and (max-width: 480px) {
      .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner {
        max-width: unset;
      }

      .kuContainer .kuContainer {
        padding-left: 0;
        padding-right: 0;
      }
    }

    @media only screen and (max-width: 470px) {
      .kuSearchResultsPageContainer .kuResults ul {
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
      }

      .kuSearchResultsPageContainer .kuResults ul li {
        padding: 10px;
      }

      .kuSearchResultsPageContainer [data-result-view='list'] .kuResults ul .kuProdWrap {
        grid-template-columns: 0 100px 2fr;
      }

      .kuSearchResultsPageContainer [data-result-view='list'] .kuResults .klevuProduct footer {
        width: 100%;
        padding-left: 10px;
      }

      .kuSearchResultsPageContainer .kuResults ul li .product-form--atc-button {
        font-size: 13px;
        max-height: unset;
      }
    }

    @media only screen and (max-width: 350px) {
      #mobile-filters-bar .utils-filter {
        margin-right: 0;
      }
    }
`;



if (typeof klevu_currency === 'undefined') {
    const activeCurrency = typeof Shopify !== 'undefined' && typeof Shopify.currency?.active !== 'undefined' ? Shopify.currency?.active : 'GBP';
    var klevu_currency = activeCurrency;
}

// currency module price formatting
(function (klevu) {
    klevu.extend(true, klevu.search.modules, {
        // modify the currency format data which the rendering engine will use
        updateCustomerCurrencyFormat: function (data, scope) {
            var currencyObj = scope.kScope.template.getTranslator().getCurrencyObject();
            currencyObj.setCurrencys({
                "GBP": {
                    string: "£",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: "",
                    decimal: ".",
                    grouping: 3
                },
                "AUD": {
                    string: "$",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: "",
                    decimal: ".",
                    grouping: 3
                },
                "CAD": {
                    string: "$",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: "",
                    decimal: ".",
                    grouping: 3
                },
                "DKK": {
                    string: "kr.",
                    format: "%s%s",
                    atEnd: true,
                    precision: 2,
                    thousands: "",
                    decimal: ",",
                    grouping: 3
                },
                "NOK": {
                    string: "kr",
                    format: "%s%s",
                    atEnd: true,
                    precision: 2,
                    thousands: " ",
                    decimal: ",",
                    grouping: 3
                },
                "EUR": {
                    string: "€",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: "",
                    decimal: ",",
                    grouping: 3
                },
                "HKD": {
                    string: "$",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: "",
                    decimal: ".",
                    grouping: 3
                },
                "JPY": {
                    string: "¥",
                    format: "%s%s",
                    atEnd: false,
                    precision: 0,
                    thousands: ".",
                    decimal: ",",
                    grouping: 3
                },
                "NZD": {
                    string: "$",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: "",
                    decimal: ".",
                    grouping: 3
                },
                "SGD": {
                    string: "$",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: "",
                    decimal: ".",
                    grouping: 3
                },
                "USD": {
                    string: "$",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: "",
                    decimal: ".",
                    grouping: 3
                },
                "THB": {
                    string: "฿",
                    format: "%s%s",
                    atEnd: true,
                    precision: 2,
                    thousands: "",
                    decimal: ".",
                    grouping: 3
                },
                "CLP": {
                    string: "$",
                    format: "%s%s",
                    atEnd: false,
                    precision: 0,
                    thousands: ",",
                    decimal: ".",
                    grouping: 3
                },
                "BRL": {
                    string: "R$",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: " ",
                    decimal: ",",
                    grouping: 3
                },
                "PHP": {
                    string: "₱",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousands: ",",
                    decimal: ".",
                    grouping: 3
                },
            }
            );
            currencyObj.mergeToGlobal();
        }
    });
})(klevu);

// currency module currency change
(function (klevu) {
    /**
     * Function to update currency in products
     * @param {*} scope 
     */
    function updateCurrency(scope) {
        var data = scope.data;
        var queryResults = klevu.getObjectPath(data, "response.current.queryResults");
        if (queryResults) {
            klevu.each(queryResults, function (key, queryResult) {
                if (queryResult && queryResult.records) {
                    klevu.each(queryResult.records, function (rKey, record) {
                        record.currency = klevu_currency;
                    });
                }
            });
        }
    }

    function updatePrices(scope) {
        var data = scope.data;
        var queryResults = klevu.getObjectPath(data, "response.current.queryResults");
        const rate = typeof Shopify !== 'undefined' && typeof Shopify.currency?.rate !== 'undefined' ? Shopify.currency?.rate : 1;
        const activeCurrency = typeof Shopify !== 'undefined' && typeof Shopify.currency?.active !== 'undefined' ? Shopify.currency?.active : 'GBP';
        const defaultRound = 0.99;
        const euroRound = 0.95;
        const wholeRound = 1.0;


        // console.trace('updating prices', scope);

        const hundredRoundedCurrencies = ['PHP', 'CLP']
        const wholeRoundCurrencies = ['THB', 'NOK', 'MYR', 'ILS', 'BRL']

        if (queryResults && activeCurrency !== 'GBP') {
            klevu.each(queryResults, function (key, queryResult) {
                if (queryResult && queryResult.records) {
                    klevu.each(queryResult.records, function (rKey, record) {
                        if(record.convertedCurrency != undefined && record.convertedCurrency == true) return

                        let startPrice = record.startPrice *= rate;
                        let price = record.price *= rate;
                        let salePrice = record.salePrice *= rate;
                        // console.log(price)

                        if (activeCurrency === 'EUR' && (Boolean(startPrice % 1) || Boolean(price % 1) || Boolean(salePrice % 1))) {
                            record.startPrice = Math.floor(startPrice) + euroRound;
                            record.price = Math.floor(price) + euroRound;
                            record.salePrice = Math.floor(salePrice) + euroRound;

                        } 
                        else if(hundredRoundedCurrencies.includes(activeCurrency)){
                            record.startPrice = Math.ceil(startPrice/100)*100;
                            record.price = Math.ceil(price/100)*100;
                            record.salePrice = Math.ceil(salePrice/100)*100;
                        }
                        else if (wholeRoundCurrencies.includes(activeCurrency)) {
                            
                            //check to see if the currency is already exactly rounded to a whole number (at 2 decimal places)
                            /// if it isn't then round it up to the nearest 1.
                            // num - Math.floor(number) !== 0 returns true if number has decimals

                            record.startPrice = (startPrice.toFixed(2) - Math.floor(startPrice.toFixed(2))) !== 0 ? Math.floor(startPrice) + wholeRound : startPrice.toFixed(2);
                            record.price = (price.toFixed(2) - Math.floor(price.toFixed(2))) !== 0 ?  Math.floor(price) + wholeRound : price.toFixed(2);
                            record.salePrice = (price.toFixed(2) - Math.floor(salePrice.toFixed(2))) !== 0 ? Math.floor(salePrice) + wholeRound : salePrice.toFixed(2);

                        } 
                        else if (activeCurrency === 'JPY') {
                            record.startPrice = Number(String(parseInt(startPrice)).replace(/\d\d$/, 99));
                            record.price = Number(String(parseInt(price)).replace(/\d\d$/, 99));
                            record.salePrice = Number(String(parseInt(salePrice)).replace(/\d\d$/, 99));
                        } else {
                            record.startPrice = Math.floor(startPrice) + defaultRound;
                            record.price = Math.floor(price) + defaultRound;
                            record.salePrice = Math.floor(salePrice) + defaultRound;
                        }
                        record.convertedCurrency = true;
                    });
                }
            });
        }
    }

    const productDataModification = {
        updateCurrency,
        updatePrices
    };

    klevu.extend(true, klevu.search.modules, {
        productDataModification: {
            base: productDataModification,
            build: true
        }
    });

})(klevu);

(function (klevu) {
    klevu.extend(true, klevu.search.modules, {
        updateFiltersList: function (data, scope) {
            klevu.each(data.request.current.recordQueries, function (key, query) {
                let existing_limit = query.settings.limit;
                klevu.setObjectPath(
                    data,
                    "localOverrides.query." + query.id + ".filters.filtersToReturn.options.limit",
                    100
                );
                klevu.setObjectPath(
                    data,
                    "localOverrides.query." + query.id + ".filters.filtersToReturn.options.minCount",
                    1
                );
                if (query.id == 'productList' && existing_limit < 24) {
                    klevu.setObjectPath(
                        data,
                        "localOverrides.query." + query.id + ".settings.limit",
                        36
                    );
                }
            });
        }
    });
})(klevu);

klevu.coreEvent.build({
    name: "setRemoteConfigQuickOverride",
    fire: function () {
        if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigQuick.build", false)) {
            return true;
        }
        return false;
    },
    maxCount: 150,
    delay: 100
});

klevu.coreEvent.attach("setRemoteConfigQuickOverride", {
    name: "attachRemoteConfigQuickOverride",
    fire: function () {
        klevu.search.landing.getScope().chains.request.control.addAfter("initRequest", {
            name: "modifyFiltersList",
            fire: function (data, scope) {
                klevu.search.modules.updateFiltersList(data, scope);
            }
        });

        klevu.each(
            klevu.search.extraSearchBox, function (key, box) {
                box.getScope().chains.template.process.success.add({
                    name: "updateProductCurrency",
                    fire: function (data, scope) {
                        var productDataModification = klevu.search.modules.productDataModification;
                        if (productDataModification) {
                            productDataModification.base.updateCurrency(scope.kScope);
                            productDataModification.base.updatePrices(scope.kScope);
                        }
                    }
                });

                // hook into the process which prepares the templates for rendering
                box.getScope().chains.template.process.success.addAfter("processCurrencySetting", {
                    name: "updateCurrencyFormat",
                    fire: function (data, scope) {
                        klevu.search.modules.updateCustomerCurrencyFormat(data, scope);
                    }
                });

                box.getScope().chains.template.events.add({
                    name: "customAfterRenderEvent",
                    fire: function (data, scope) {
                        window._conv_q = window._conv_q || [];  _conv_q.push(["triggerConversion", "100439119"]);
                        }
                    });
            }
        );

        klevu.dom.helpers.addElementToHead({
            name: "klevu-custom-styles",
            content: customStyleContent,
            type: "css"
        });

        klevu({
            powerUp: {
                quick: true
            }
        });
    }
});

// landing
klevu.coreEvent.build({
    name: "setRemoteConfigLandingOverride",
    fire: function () {
        if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build", false)) {
            return true;
        }
        return false;
    },
    maxCount: 150,
    delay: 100
});

klevu.coreEvent.attach("setRemoteConfigLandingOverride", {
    name: "attachRemoteConfigLandingOverride",
    fire: function (data, scope) {
        document.getElementsByTagName('body')[0].classList.add('ku-klevu');

            console.log('attach remove config landing override');

        klevu.search.landing.getScope().template.setTemplate(klevuLandingTemplateProductBlockCustom, "productBlock", true);
        klevu.search.landing.getScope().template.setTemplate(customPaginationTemplate, "pagination", true);
        klevu.search.landing.getScope().template.setTemplate(customLandingTemplateLimit, "limit", true);
        klevu.search.landing.getScope().template.setTemplate(customLandingTemplateResults, "results", true);
        klevu.search.landing.getScope().template.setTemplate(customLandingTemplateFilters, "filters", true);
        klevu.search.landing.getScope().template.setTemplate(customNoResults, "noResultsLandingPopularProductsTemplate", true);

        klevu.search.landing.getScope().chains.template.process.success.add({
            name: "updateProductCurrency",
            fire: function (data, scope) {
                var productDataModification = klevu.search.modules.productDataModification;
                if (productDataModification) {
                    productDataModification.base.updateCurrency(scope.kScope);
                    productDataModification.base.updatePrices(scope.kScope);
                }
            }
        });

        // klevu.search.landing.getScope().chains.template.process.success.add({
        //   name: "updateFiltersList",
        //   fire: function (data, scope) {

        //     klevu.search.modules.updateFiltersList(data, scope);

        // let search_term = data.context.term;
        // console.log(search_term);
        console.log(data);

        // var myHeaders = new Headers();
        // myHeaders.append("Content-Type", "application/json");

        // var raw = JSON.stringify({
        //   "context": {
        //     "apiKeys": [
        //       "klevu-163067900222714176"
        //     ]
        //   },
        //   "recordQueries": [
        //     {
        //       "id": "productSearch",
        //       "typeOfRequest": "SEARCH",
        //       "settings": {
        //         "searchPrefs": [
        //           "showFiltersWithSmallCount"
        //         ],
        //         "query": {
        //           "term": search_term
        //         },
        //         "limit": 0,
        //         "typeOfRecords": [
        //           "KLEVU_PRODUCT"
        //         ],
        //         "fields": [
        //           "id",
        //           "name"
        //         ]
        //       },
        //       "filters": {
        //         "filtersToReturn": {
        //           "enabled": true,
        //           "options": {
        //             "order": "FREQ",
        //             "limit": 100
        //           },
        //           "rangeFilterSettings": [
        //             {
        //               "key": "klevu_price",
        //               "minMax": true,
        //               "rangeInterval": 1
        //             }
        //           ]
        //         }
        //       }
        //     }
        //   ]
        // });

        // var requestOptions = {
        //   method: 'POST',
        //   headers: myHeaders,
        //   body: raw,
        //   redirect: 'follow'
        // };

        // fetch("https://rwcsv2.ksearchnet.com/cs/v2/search", requestOptions)
        //   .then(response => response.text())
        //   .then((result) => {
        //     let result_array = JSON.parse(result);
        //     console.log(result_array);
        //     filters_array = result_array.queryResults[0].filters;
        //     console.log(filters_array);

        //     console.log('get data');
        //     console.log(klevu.search.landing.getScope().chains.template.getData());
        //     klevu.search.landing.getScope().chains.setData(result_array.queryResults[0]);
        //   })
        //   .catch(error => console.log('error', error));
        //   }
        // });

        klevu.search.landing.getScope().chains.template.process.success.add({
            name: "inputSearchTerms",
            fire: function (data, scope) {
                //         console.log(data);
                document.querySelector('.empire-search-form-field').value = data.context.term;

                if (data.response.data && Object.keys(data.response.data).length > 0) {
                    if (data.response.data.queryResults[0].meta.totalResultsFound == 0) {
                        //             console.log('show continue shopping');
                        document.querySelector('#mobile-filters-bar').style.display = 'none';
                        document.querySelector('#no-results-hidden-input').setAttribute('value', 1);
                        document.querySelector('#shopify-section-dynamic-logo-list').style.display = 'block';
                    }
                }
            }
        });

        klevu.search.landing.getScope().chains.request.control.addAfter("initRequest", {
            name: "resetSorting",
            fire: function (data, scope) {
                if (localStorage.getItem('klv_sort_productList') !== null) {
                    localStorage.removeItem('klv_sort_productList');
                }
            }
        });

        // hook into the process which prepares the templates for rendering
        klevu.search.landing.getScope().chains.template.process.success.addAfter("processCurrencySetting", {
            name: "updateCurrencyFormat",
            fire: function (data, scope) {
                klevu.search.modules.updateCustomerCurrencyFormat(data, scope);
            }
        });

        klevu({
            powerUp: {
                landing: true
            }
        });

    }
});


// CatNav
klevu.coreEvent.attach("setRemoteConfigCategoryOverride", {
    name: "attachRemoteConfigCategoryOverride",
    fire: function () {
        document.getElementsByTagName('body')[0].classList.add('ku-klevu ku-catnav-klevu');

            console.log('load catnav block');

        klevu.search.catnav.getScope().template.setTemplate(klevuLandingTemplateProductBlockCustom, "productBlock", true);

        klevu.search.catnav.getScope().chains.template.process.success.add({
            name: "updateProductCurrency",
            fire: function (data, scope) {
                var productDataModification = klevu.search.modules.productDataModification;
                if (productDataModification) {
                    productDataModification.base.updateCurrency(scope.kScope);
                    productDataModification.base.updatePrices(scope.kScope);
                }
            }
        });

        // hook into the process which prepares the templates for rendering
        klevu.search.catnav.getScope().chains.template.process.success.addAfter("processCurrencySetting", {
            name: "updateCurrencyFormat",
            fire: function (data, scope) {
                klevu.search.modules.updateCustomerCurrencyFormat(data, scope);
            }
        });


        klevu({
            powerUp: {
                catnav: true
            }
        });
    }
});
const klevuLandingTemplateProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;

    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }

    var discount = 0;
    if (parseInt(dataLocal.salePrice) < parseInt(dataLocal.price)) {
        let price = parseFloat(dataLocal.salePrice);
        let compare_price = parseFloat(dataLocal.price);
        let difference = compare_price - price;
        let difference_percentage = (difference / compare_price)*100;
        discount = parseInt(Math.round(difference_percentage));
    }

    var preOrder = false;

    if (dataLocal.tags)
    {
        var tagsArray = dataLocal.tags.split(',');
      
        if (tagsArray.includes('Pre-Order')) 
        {
            preOrder = true;
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <div class="kuProdWrap">
        <header ku-block data-block-id="ku_landing_result_item_header">
            <%=helper.render('landingProductBadge', scope, data, dataLocal) %>
        </header>
        <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
        <main ku-block data-block-id="ku_landing_result_item_info">
            <div class="kuProdTop">
                <!--<div class="klevuImgWrap">-->
                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView">
                        <img src="<%=dataLocal.image%>" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                        <%=helper.render('landingImageRollover', scope, data, dataLocal) %>                        
                        <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                            <span class="discountLabel soldOutLabel">Sold Out</span>
                        <% } else if (discount > 0) { %>
                            <span class="discountLabel">Save <%= discount %>%</span>
                        <% } %>
                        <% if (preOrder) { %>
                          <span class="preorder-badge">Pre-Order</span>
                        <% } %>
                    </a>                        
                <!--</div>-->
                <!-- <div class="kuQuickView">
                    <button data-id="<%=dataLocal.id%>" class="kuBtn kuBtnLight kuQuickViewBtn" role="button" tabindex="0" area-label="">Quick view</button>
                </div> -->
            </div>
        </main>
        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
            <div class="kuProdBottom">               
                <div class="priceRow">

                    <!-- klevu.search.modules.kmcInputs.base.getShowPrices() -->
                    <% if( true ) { %>



                        <div class="kuPrice">
                            <%
                                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                            %>

                            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>
                                <div class="kuSalePrice kuStartPrice kuClippedOne">
                                    <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                                </div>
                            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                                <span class="kuOrigPrice kuClippedOne">
                                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                                </span>
                                <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                                </span>
                            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                                <span class="kuSalePrice kuSpecialPrice">
                                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                                </span>
                            <% } else if(!Number.isNaN(kuPrice)) { %>
                                <span class="kuSalePrice">
                                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                                </span>
                            <% } %>
                            <%=helper.render('searchResultProductVATLabel', scope, data, dataLocal) %>
                        </div>
                    <% } %>
                    

                    <div class="productType">
                        <%
                            var product_type = '';
                            if (dataLocal.category) {
                                let found_product_type = dataLocal.category.split(";;").pop();
                                if (found_product_type != 'All' && found_product_type != 'ALL') {
                                    product_type = found_product_type;
                                }
                            }
                        %>
                        <span><%= product_type %></span>
                    </div>
                </div>
                <div class="kuName kuClippedOne"><a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div>

                <div class="artistAuthor">
                    <%
                        var artist_author = '';
                        if (dataLocal.artist) {
                            artist_author = dataLocal.artist;
                            
                        }
                        else if (dataLocal.author) {
                            artist_author = dataLocal.author;
                        }
                        if(artist_author.startsWith('[') && artist_author.endsWith(']')){
                            artist_author = artist_author.slice(1, artist_author.length -1);
                        }
                    %>
                    <span><%= artist_author %></span>
                </div>

            </div>
            
          </footer>             
    </div>
<button class="product-form--atc-button <% if (dataLocal.inStock && dataLocal.inStock != "yes") { %> disabled <% } else { if (preOrder) { %> preorder-button <% } } %>" type="submit" data-product-id="<%=dataLocal.id %>" data-product-atc <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %> disabled <% } %>>
        <span class="atc-button--text">
<% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>Sold out<% } else { if (preOrder) { %>Pre-Order<% } else { %>Add to basket<% } } %>
		</span>
        <span class="atc-button--icon"><svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
        <g fill-rule="nonzero" fill="currentColor">
          <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path>
        </g>
      </svg></span>
    </button>
</li>`;

const customPaginationTemplate = `<% if(data.query[dataLocal].result.length > 0 ) { %> 
  <% var productListLimit = data.query[dataLocal].meta.noOfResults; %> 
  <% var productListTotal = data.query[dataLocal].meta.totalResultsFound - 1; %> 
  <div class="kuPagination"> 
  <% if(data.query[dataLocal].meta.offset > 0) { %> 
      <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="0">&lt;&lt;</a>
      <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset-productListLimit)%>">&lt;</a>
  <% } %> 
  <% if(data.query[dataLocal].meta.offset > 0) { %> 
      <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset-productListLimit)%>"><%=(Math.ceil(data.query[dataLocal].meta.offset/productListLimit))%></a>
  <% } %> 
      <a href="javascript:void(0);" class="kuCurrent"><%=(Math.ceil(data.query[dataLocal].meta.offset/productListLimit)+1)%></a>
      <% if(productListTotal >= data.query[dataLocal].meta.offset+productListLimit) { %> 
          <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset+productListLimit)%>"><%=(Math.ceil(data.query[dataLocal].meta.offset/productListLimit)+2)%></a>
          <% if(productListTotal >= data.query[dataLocal].meta.offset+(productListLimit*2)) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset+(productListLimit*2))%>"><%=(Math.ceil(data.query[dataLocal].meta.offset/productListLimit)+3)%></a>
            <% if(productListTotal >= data.query[dataLocal].meta.offset+(productListLimit*3)) { %>
              <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset+(productListLimit*3))%>"><%=(Math.ceil(data.query[dataLocal].meta.offset/productListLimit)+4)%></a>
            <% } %>
          <% } %>
      <% } %> 
      <% if(productListTotal >= data.query[dataLocal].meta.offset+productListLimit) { %> 
          <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset+productListLimit)%>">&gt;</a>
          <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(Math.floor(productListTotal/productListLimit)*productListLimit)%>">&gt;&gt;</a> 
      <% } %> 
  </div> 
<% } %>`;

const customLandingTemplateLimit = `
<div class="kuDropdown kuDropItemsPerpage">
<div class="kuDropdownLabel">Items per page : <%=data.query[dataLocal].meta.noOfResults%></div>
<div class="kuDropdownOptions">
    <div class="kuDropOption kuLimit" data-value="24">24</div>
    <div class="kuDropOption kuLimit" data-value="36">36</div>
    <div class="kuDropOption kuLimit" data-value="48">48</div>
</div>
</div>
`;

const customLandingTemplateResults = `
<div class="kuResultsListing">
<div class="productList klevuMeta" data-section="productList">
    <div class="kuResultContent">
        <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">
            <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                    <div ku-block data-block-id="ku_landing_left_facets"><%=helper.render('filters',scope,data,"productList") %></div>
                    <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                    <div ku-block data-block-id="ku_landing_left_banner"></div>
                </section>
                <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                    <header ku-block data-block-id="ku_landing_result_header">
                        <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %> <%=helper.render('filtersTop',scope,data,"productList") %> <%=
                        helper.render('kuFilterTagsTemplate',scope,data,"productList") %> <% if(helper.hasResults(data,"productList")) { %> <%=helper.render('sortBy',scope,data,"productList") %>
                        <%=helper.render('limit',scope,data,"productList") %> <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %> <%=helper.render('pagination',scope,data,"productList") %> <% } %>
                        <div class="kuClearBoth"></div>
                    </header>
                    <div ku-block data-block-id="ku_mobile_pagination" id="mobile-top-pagination"><%=helper.render('pagination',scope,data,"productList") %></div>
                    <div ku-block data-block-id="ku_landing_result_items">
                        <div class="kuResults">
                            <% if(helper.hasResults(data,"productList")) { %>
                            <ul>
                                <% helper.each(data.query.productList.result,function(key,item){ %> <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %> <%=helper.render('productBlock',scope,data,item) %> <% } %> <% }); %>
                            </ul>
                            <% } else { %>
                            <div class="kuNoRecordsFoundLabelTextContainer"><span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span></div>
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </div>
                    </div>
                    <div ku-block data-block-id="ku_landing_other_items"><%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %></div>
                    <footer ku-block data-block-id="ku_landing_result_footer"><%=helper.render('pagination',scope,data,"productList") %></footer>
                </section>
                <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                    <div ku-block data-block-id="ku_landing_right_facets"></div>
                    <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                    <div ku-block data-block-id="ku_landing_right_banner"></div>
                </section>
            </div>
        </div>
    </div>
</div>
<% if(data.query.contentList) { %>
<div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
    <div class="kuResultContent">
        <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">
            <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                    <div ku-block data-block-id="ku_landing_left_facets"><%=helper.render('filters',scope,data,"contentList") %></div>
                    <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                    <div ku-block data-block-id="ku_landing_left_banner"></div>
                </section>
                <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                    <header ku-block data-block-id="ku_landing_result_header">
                        <%=helper.render('filtersTop',scope,data,"contentList") %> <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %> <% if(helper.hasResults(data,"contentList")) { %>
                        <%=helper.render('limit',scope,data,"contentList") %> <%=helper.render('pagination',scope,data,"contentList") %> <% } %>
                        <div class="kuClearBoth"></div>
                    </header>
                    <div ku-block data-block-id="ku_landing_result_items">
                        <div class="kuClearBoth"></div>
                        <div class="kuResults">
                            <% if(helper.hasResults(data,"contentList")) { %>
                            <ul>
                                <% helper.each(data.query.contentList.result,function(key,item){ %> <% if(item.typeOfRecord == "KLEVU_CMS") { %> <%=helper.render('contentBlock',scope,data,item) %> <% }%> <% }); %>
                            </ul>
                            <% } else { %>
                            <div class="kuNoRecordsFoundLabelTextContainer"><span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span></div>
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </div>
                    </div>
                    <div ku-block data-block-id="ku_landing_other_items"><%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %></div>
                    <footer ku-block data-block-id="ku_landing_result_footer"><%=helper.render('pagination',scope,data,"contentList") %></footer>
                </section>
                <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                    <div ku-block data-block-id="ku_landing_right_facets"></div>
                    <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                    <div ku-block data-block-id="ku_landing_right_banner"></div>
                </section>
            </div>
        </div>
    </div>
</div>
<% } %>
</div>
`;

const customLandingTemplateFilters = `<% 


if(data.query[dataLocal].filters.length > 0 ) { %> 
  <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0"> 
      <h3 class="kuFiltersTitleHeading">Filter by</h3> 
      <% helper.each(data.query[dataLocal].filters,function(key,filter){ %> 
          <% if(filter.type == "OPTIONS"){ %> 
              <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>> 
                  <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>"> 
                      <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %> <%=helper.translate(filter_label)%> 
                  </div> 
                  <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>"> 
                      <ul> 
                          <% helper.each(filter.options,function(key,filterOption){ %> 
                              <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>> 
                                  <a target="_self" href="#" title="<%=helper.escapeHTML(filterOption.name)%>" class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" data-value="<%=helper.escapeHTML(filterOption.value)%>" > 
                                      <span class="kuFilterIcon"></span> 
                                      <span class="kufacet-text"><%=filterOption.name%></span> 
                                      <% if(filterOption.selected ==true) { %> 
                                          <span class="kuFilterCancel">X</span> 
                                      <% } else { %> 
                                          <span class="kuFilterTotal"><%=filterOption.count%></span> 
                                      <% } %> 
                                  </a> 
                              </li> 
                          <% }); %> 
                      </ul> 
                      <% if(filter.options.length > 5 ) { %> 
                          <div class="kuShowOpt" tabindex="-1"> 
                              <span class="kuFilterDot"></span>
                              <span class="kuFilterDot"></span>
                              <span class="kuFilterDot"></span> 
                          </div> 
                      <% } %> 
                  </div> 
              </div> 
          <% } else if(filter.type == "SLIDER") { %> 
              <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>"> 
                  <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>"> 
                      <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %> <%=helper.translate(filter_label)%> 
                  </div> 
                  <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>"> 
                      <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>"> 
                          <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div> 
                      </div> 
                  </div> 
              </div> 
          <% } else { %> 
              <!-- Other Facets --> 
          <% } %> 
      <% }); %> 
      <!-- <div class="kuFiltersFooter"> <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a> </div> --> 
  </div> 
<% } %>`;

const customNoResults = `<div class="kuNoResultsProductRecommendationSlider kuNoResultsPopularProducts" data-section="noResultsFoundPopularProductList"> 
<% var popularProductList = klevu.getObjectPath(data,"query.noResultsFoundPopularProductList.result");%> 
<% if(popularProductList && popularProductList.length) { %> 
    <div class="klevuNoResultsRecs" title="<%= helper.translate(data.landingNoResultsPopularHeading) %>"> 
        <h3><%= helper.translate(data.landingNoResultsPopularHeading) %> </h3> 
    </div> 
    <div class="klevuNoResultsRecsWrap"> 
        <div class="klevuNoResultsRecsResults"> 
            <div class="klevuNoResultsRecsResultsInner"> 
                <div class="kuSearchResultsPageContainer">
                    <div class="kuResults">
                        <ul>
                            <% helper.each(popularProductList, function(key, dataLocal){ %>         
                                <% 
                                
                                var updatedProductName = dataLocal.name;

                                    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
                                        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
                                            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
                                        }
                                    }

                                    var discount = 0;
                                    if (dataLocal.salePrice < dataLocal.price) {
                                        let price = parseFloat(dataLocal.salePrice);
                                        let compare_price = parseFloat(dataLocal.price);
                                        let difference = compare_price - price;
                                        let difference_percentage = (difference / compare_price)*100;
                                        discount = parseInt(Math.round(difference_percentage));
                                    }

                                    var preOrder = false;

                                    if (dataLocal.tags)
                                    {
                                        var tagsArray = dataLocal.tags.split(',');
                                      
                                        if (tagsArray.includes('Pre-Order')) 
                                        {
                                            preOrder = true;
                                        }
                                    }
                                %>
                                <li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
                                    <div class="kuProdWrap">
                                        <header ku-block data-block-id="ku_landing_result_item_header">
                                            <%=helper.render('landingProductBadge', scope, data, dataLocal) %>
                                        </header>
                                        <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
                                        <main ku-block data-block-id="ku_landing_result_item_info">
                                            <div class="kuProdTop">
                                                <!--<div class="klevuImgWrap">-->
                                                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView">
                                                        <img src="<%=dataLocal.image%>" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                                                        <%=helper.render('landingImageRollover', scope, data, dataLocal) %>                        
                                                        <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                                                            <span class="discountLabel soldOutLabel">Sold Out</span>
                                                        <% } else if (discount > 0) { %>
                                                            <span class="discountLabel">Save <%= discount %>%</span>
                                                        <% } %>
                                                        <% if (preOrder) { %>
                                                          <span class="preorder-badge">Pre-Order</span>
                                                        <% } %>
                                                    </a>                        
                                                <!--</div>-->
                                                <!-- <div class="kuQuickView">
                                                    <button data-id="<%=dataLocal.id%>" class="kuBtn kuBtnLight kuQuickViewBtn" role="button" tabindex="0" area-label="">Quick view</button>
                                                </div> -->
                                            </div>
                                        </main>
                                        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
                                            <div class="kuProdBottom">               
                                                <div class="priceRow">

                                                    <!-- klevu.search.modules.kmcInputs.base.getShowPrices() -->
                                                    <% if( true ) { %>



                                                        <div class="kuPrice">
                                                            <%
                                                                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                                                                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                                                                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                                                                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                                                            %>

                                                            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>
                                                                <div class="kuSalePrice kuStartPrice kuClippedOne">
                                                                    <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                                                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                                                                </div>
                                                            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                                                                <span class="kuOrigPrice kuClippedOne">
                                                                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                                                                </span>
                                                                <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                                                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                                                                </span>
                                                            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                                                                <span class="kuSalePrice kuSpecialPrice">
                                                                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                                                                </span>
                                                            <% } else if(!Number.isNaN(kuPrice)) { %>
                                                                <span class="kuSalePrice">
                                                                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                                                                </span>
                                                            <% } %>
                                                            <%=helper.render('searchResultProductVATLabel', scope, data, dataLocal) %>
                                                        </div>
                                                    <% } %>
                                                    

                                                    <div class="productType">
                                                        <%
                                                            var product_type = '';
                                                            if (dataLocal.category) {
                                                                let found_product_type = dataLocal.category.split(";;").pop();
                                                                if (found_product_type != 'All' && found_product_type != 'ALL') {
                                                                    product_type = found_product_type;
                                                                }
                                                            }
                                                        %>
                                                        <span><%= product_type %></span>
                                                    </div>
                                                </div>
                                                <div class="kuName kuClippedOne"><a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div>

                                                <div class="artistAuthor">
                                                    <%
                                                        var artist_author = '';
                                                        if (dataLocal.artist) {
                                                            artist_author = dataLocal.artist;
                                                        }
                                                        else if (dataLocal.author) {
                                                            artist_author = dataLocal.author;
                                                        }
                                                        if(artist_author.startsWith('[') && artist_author.endsWith(']')){
                                                            artist_author = artist_author.slice(1, artist_author.length -1);
                                                        }
                                                    %>
                                                    <span><%= artist_author %></span>
                                                </div>

                                            </div>
                                            
                                          </footer>             
                                    </div>
                                </li>
        
                            <% }) %>
                        </ul>
                    </div>
                </div> 
            </div> 
        </div> 
    </div> 
<!-- </div>  -->
<% } %> 
</div>`;

/** <div class="kuProdAdditional">
    <div class="kuProdAdditionalData">
        <% if(desc && desc.length) { %>
            <div class="kuDesc kuClippedTwo"> <%=desc%> </div>
        <% } %>
        <%=helper.render('landingProductSwatch',scope,data,dataLocal) %>
        <% if(typeof dataLocal.rating != "undefined" && dataLocal.rating ! == "") { %>
            <div class="klevu-stars-small-l2">
                <div class="klevu-rating-l2" style="width:<%=(20*Number(dataLocal.rating))%>%;"></div>
            </div>
        <% } %>
        <% var isAddToCartEnabled = klevu.search.modules.kmcInputs.base.getAddToCartEnableValue(); %>
        <% if(isAddToCartEnabled) { %>
            <%=helper.render('landingPageProductAddToCart',scope,data,dataLocal) %>
        <% } %>
    <div>
</div> */


/** additional scripts */

// klevu.interactive(
//   function(){
//     console.log("document is loaded")
//     var images = document.querySelectorAll('.klevuImgWrap img');
//     console.log(images)
//   }
// );

// document.addEventListener("DOMContentLoaded", function(event) {
//   var images = document.querySelectorAll('.klevuImgWrap img');
//   console.log(images)
// });
